import { object, string } from "yup";
import type { ImportType } from "~/models/ImportLog";

export type ImportConversion = {
	columnName: string;
	convertedValue: string;
	id: number;
	importType: ImportType;
	originalValue: string;
};

export type ImportConversionParam = Omit<ImportConversion, "id">;

export const buildDefault = (
	importType: ImportType
): ImportConversionParam => ({
	columnName: "",
	convertedValue: "",
	importType,
	originalValue: ""
});

export const validationSchema = object({
	columnName: string().required("入力してください"),
	convertedValue: string().required("入力してください"),
	originalValue: string().required("入力してください")
});
